import betslip from '@gin-betting/betslip';
import { API, App } from '@gin-betting/core';

import type { IBetslipTimeManager } from './types';

const {
    constants: { ErrorCodes },
} = betslip;

export const DELETE_BETSLIP_ODD_DELAY = 2000;
export const DELETE_BETSLIP_ODD_DELAY_MOB = 5000;

export const RESTRICTION_BLACK_LIST = [
    API.RestrictionType.bet_delay,
    API.RestrictionType.selection_value,
    API.RestrictionType.sport_event_status,
    API.RestrictionType.sport_event_bet_stop,
    API.RestrictionType.market_status,
    API.RestrictionType.odd_status,
    API.RestrictionType.not_enough_balance,
] as const;

export const RESTRICTION_BLACKLIST_BY_BETSLIP_STATUS = {
    [App.BetslipStatus.ERROR]: [
        API.RestrictionType.max_bet,
        API.RestrictionType.bet_delay,
        API.RestrictionType.not_enough_balance,
    ],
};

export const ODDS_CHANGE_DECLINE_REASONS = [
    ErrorCodes.ApiOddValueWrong,
    ErrorCodes.InvalidSelectionValue,
] as const;

export const NOT_ENOUGH_BALANCE_REASON_LIST = [
    ErrorCodes.NotEnoughBalance1,
    ErrorCodes.NotEnoughBalance2,
] as const;

export const GROUP_OF_ODDS_CLASS = '__app-GroupOfOdds-container' as const;

export const BetslipTimeManager: IBetslipTimeManager = {};

export const PART_OF_NOT_ENOUGH_DOCS_ERROR = 'de-kyc-deposit' as const;

export const INPUT_VARIANT_COUNT = 5 as const;
export const DEFAULT_VARIANT_POSITION = 2 as const;
